// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--2RQcN";
export var inputGroupLg = "styles-module--input-group-lg--8_ibR";
export var arrow = "styles-module--arrow--yLSgq";
export var up = "styles-module--up--1FYw2";
export var down = "styles-module--down--3U7xJ";